if (!customElements.get('germano-product-shipping')) {
  customElements.define('germano-product-shipping', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.strings = JSON.parse(this.querySelector('.ge-shipping__strings').textContent);
      this.form = this.querySelector('.ge-shipping__form');
      this.status = this.querySelector('.ge-shipping__status');
      this.results = this.querySelector('.ge-shipping__results');
      this.addLink = this.querySelector('.ge-shipping__add');
      this.onSubmit = event => { event.preventDefault(); this.calculate(); };
      this.onChange = () => { this.controller?.abort(); this.results.hidden = true; this.addLink.hidden = true; this.status.textContent = this.strings.cart_changed; };
      this.form.addEventListener('submit', this.onSubmit);
      this.form.addEventListener('input', this.onChange);
      this.productScope = document.getElementById(this.dataset.formId)?.closest('.shopify-section') || this.closest('.m-product-info') || this.parentElement.parentElement;
      this.productScope.addEventListener('change', this.onChange);
      this.cartChange = () => { if (!this.results.hidden) this.onChange(); };
      document.addEventListener('cart:updated', this.cartChange);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.form?.removeEventListener('submit', this.onSubmit);
      this.form?.removeEventListener('input', this.onChange);
      this.productScope?.removeEventListener('change', this.onChange);
      document.removeEventListener('cart:updated', this.cartChange);
      this.initialized = false;
    }
    async request(path, options = {}) {
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
      const response = await fetch(`${root}${path}`, {credentials:'same-origin', signal:this.controller.signal, ...options});
      if (!response.ok) throw new Error('shipping-request');
      return response.status === 202 ? null : response.json();
    }
    async calculate() {
      if (this.busy) return;
      const zip = this.form.elements.zip.value.replace(/\D/g, '');
      const province = this.form.elements.province.value;
      if (zip.length !== 8 || !province) { this.status.textContent = this.strings.invalid; return; }
      this.controller?.abort();
      this.controller = new AbortController();
      this.busy = true;
      const button = this.form.querySelector('button');
      button.disabled = true;
      this.results.hidden = true;
      this.addLink.hidden = true;
      this.status.textContent = this.strings.loading;
      const timeout = setTimeout(() => this.controller.abort(), 25000);
      try {
        const productForm = document.getElementById(this.dataset.formId);
        if (!productForm) throw new Error('missing-product');
        const selection = new FormData(productForm);
        const variant = String(selection.get('id') || '');
        const quantity = Math.max(1, Number(selection.get('quantity') || 1));
        const cart = await this.request('cart.js');
        const present = cart.items.filter(item => String(item.variant_id) === variant);
        if (!present.length) {
          this.status.textContent = this.strings.add_first;
          this.addLink.hidden = false;
          return;
        }
        if (present.reduce((sum,item) => sum + item.quantity,0) < quantity) {
          this.status.textContent = this.strings.quantity;
          this.addLink.hidden = false;
          return;
        }
        const params = new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'Brazil','shipping_address[province]':province});
        await this.request(`cart/prepare_shipping_rates.json?${params}`, {method:'POST'});
        let response = null;
        for (let attempt = 0; attempt < 12; attempt++) {
          response = await this.request(`cart/async_shipping_rates.json?${params}`);
          if (response !== null) break;
          await new Promise(resolve => setTimeout(resolve, 1000));
          if (this.controller.signal.aborted) throw new DOMException('Cancelled','AbortError');
        }
        if (response === null) { this.status.textContent = this.strings.timeout; return; }
        const rates = response.shipping_rates;
        if (!Array.isArray(rates)) throw new Error('invalid-shipping-response');
        if (!rates.length) { this.status.textContent = this.strings.empty; return; }
        const list = this.results.querySelector('ul');
        list.replaceChildren();
        const formatter = new Intl.NumberFormat('pt-BR',{style:'currency',currency:cart.currency || this.dataset.currency || 'BRL'});
        rates.forEach(rate => {
          const amount = Number(rate.price);
          if (!Number.isFinite(amount) || amount < 0) return;
          const row = document.createElement('li');
          const label = document.createElement('span');
          label.textContent = rate.presentment_name || rate.name;
          const days = Array.isArray(rate.delivery_days) ? rate.delivery_days.filter(day => Number.isFinite(day) && day >= 0) : [];
          const preparation = Number(this.dataset.preparationDays);
          const posting = Number(this.dataset.postingDays);
          const duration = value => `${value} ${value === 1 ? this.strings.day : this.strings.days}`;
          const preparationText = this.strings.preparation.replace('__PREPARATION__', duration(preparation)).replace('__POSTING__', duration(posting));
          let detail;
          if (days.length) {
            const minimum = Math.min(...days);
            const maximum = Math.max(...days);
            const transport = minimum === maximum ? duration(maximum) : `${minimum}–${duration(maximum)}`;
            detail = this.strings.combined.replace('__TRANSPORT__', transport).replace('__PREPARATION__', duration(preparation)).replace('__POSTING__', duration(posting)).replace('__TOTAL__', duration(maximum + preparation + posting));
          } else {
            detail = `${rate.description || this.strings.transport_unavailable} ${preparationText}`;
          }
          const time = document.createElement('span');
          time.className = 'ge-shipping__time';
          time.textContent = detail;
          label.append(time);
          const price = document.createElement('span');
          price.className = 'ge-shipping__price';
          price.textContent = amount === 0 ? this.strings.free : formatter.format(amount);
          row.append(label,price); list.append(row);
        });
        if (!list.childElementCount) throw new Error('invalid-shipping-rates');
        this.status.textContent = '';
        this.results.hidden = false;
      } catch (error) {
        this.status.textContent = error.name === 'AbortError' ? this.strings.timeout : this.strings.error;
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        button.disabled = false;
      }
    }
  });
}

